import { SelectedSupportCase } from './reducer';
import {
  GetSupportCaseWidgetUrlResponse,
  GetSupportUnreadCasesWithLastMessageResponse,
  GetSupportWidgetMqttConnectionInfoResponse,
  GetSupportWidgetUrlResponse,
} from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProviderPortal/apis';
import { ActionType, createAction, createAsyncAction } from 'typesafe-actions';

export const getMainEntryWidgetUrlAsyncAction = createAsyncAction(
  '@support/GET_MAIN_ENTRY_WIDGET_URL',
  '@support/GET_MAIN_ENTRY_WIDGET_URL_SUCCESS',
  '@support/GET_MAIN_ENTRY_WIDGET_URL_FAILURE',
)<void, GetSupportWidgetUrlResponse, Error>();

export const getSupportCaseWidgetUrlAsyncAction = createAsyncAction(
  '@support/GET_SUPPORT_CASE_WIDGET_URL',
  '@support/GET_SUPPORT_CASE_WIDGET_URL_SUCCESS',
  '@support/GET_SUPPORT_CASE_WIDGET_URL_FAILURE',
)<void, GetSupportCaseWidgetUrlResponse, Error>();

export const getUnreadCasesWithLastMessageAsyncAction = createAsyncAction(
  '@support/GET_UNREAD_CASES_WITH_LAST_MESSAGE_URL',
  '@support/GET_UNREAD_CASES_WITH_LAST_MESSAGE_SUCCESS',
  '@support/GET_UNREAD_CASES_WITH_LAST_MESSAGE_FAILURE',
)<void, GetSupportUnreadCasesWithLastMessageResponse, Error>();

export const getSupportWidgetMqttConnectionInfoAsyncAction = createAsyncAction(
  '@support/GET_SUPPORT_WIDGET_MQTT_CONNECTION_INFO',
  '@support/GET_SUPPORT_WIDGET_MQTT_CONNECTION_INFO_SUCCESS',
  '@support/GET_SUPPORT_WIDGET_MQTT_CONNECTION_INFO_FAILURE',
)<void, GetSupportWidgetMqttConnectionInfoResponse, Error>();

export const setSelectedSupportCaseAction = createAction(
  '@support/SET_SELECTED_SUPPORT_CASE',
)<SelectedSupportCase>();

export const resetSelectedSupportCaseAction = createAction(
  '@support/RESET_SELECTED_SUPPORT_CASE',
)<void>();

export const resetSupportWidgetDataAction = createAction(
  '@support/RESET_SUPPORT_WIDGET_DATA_ACTION',
)<void>();

export type SupportActions =
  | ActionType<typeof getMainEntryWidgetUrlAsyncAction>
  | ActionType<typeof getSupportCaseWidgetUrlAsyncAction>
  | ActionType<typeof getUnreadCasesWithLastMessageAsyncAction>
  | ActionType<typeof getSupportWidgetMqttConnectionInfoAsyncAction>
  | ActionType<typeof setSelectedSupportCaseAction>
  | ActionType<typeof resetSelectedSupportCaseAction>
  | ActionType<typeof resetSupportWidgetDataAction>;
